import React, { useContext } from "react";
import SideBarStyles from "../../Styles/ChannelViewer/SideBar.module.css";
import FetchChannelUSers from "./FetchChannelUSers";
import ChannelDetails from "./ChannelDetails";
import ChannelUserHeaders from "./ChannelUserHeaders";
import { ContextForClient } from "../../Context_file/ClientContext";

const UserSideBar = () => {
  const { container, wrapper } = SideBarStyles;
  const [{ resizeFlag }] = useContext(ContextForClient);
  return (
    <aside className={container}>
      <ChannelUserHeaders />
      {resizeFlag && (
        <>
          <div>
            <ChannelDetails />
          </div>

          <div className={`d-flex container ${wrapper}`}>
            <FetchChannelUSers />
          </div>
        </>
      )}
    </aside>
  );
};

export default UserSideBar;
